export default __webpack_public_path__ + "static/media/bootstrap.d9928e98.svg";